/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./globalControl.vue?vue&type=template&id=ba7c1408&scoped=true&"
import script from "./globalControl.vue?vue&type=script&lang=js&"
export * from "./globalControl.vue?vue&type=script&lang=js&"
import style0 from "./globalControl.vue?vue&type=style&index=0&id=ba7c1408&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7c1408",
  null
  
)

export default component.exports